import { Translate } from '@chipinside/translate'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import { Icon } from '#/components/Icon'
import Palette from '#/styles/Palette'

const NoLocationWrapper = styled('div')({
  alignItems: 'center',
  background: Palette.gray.self['200'],
  borderRadius: 16,
  color: Palette.gray.self['500'],
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  height: '100%',
  justifyContent: 'center',
  minHeight: 350,
  overflow: 'hidden',
})

export default function MapsNoLocation() {
  return (
    <NoLocationWrapper>
      <Icon name="map-pinned" size={50} />
      <Typography variant="h4">{Translate({ messageKey: 'no_location_registered' })}</Typography>
    </NoLocationWrapper>
  )
}
